import { Injectable, EventEmitter } from '@angular/core';
import { Questionnaire, Question } from '../questionnaire/questionnaire.service';
import { I18nHelperService } from '@xref/ngx';
import * as Cookies from 'js-cookie';
import constants from 'src/app/shared/constants';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BuilderService {

  questionnaire: Questionnaire = {
    id: '',
    title: '',
    questions: []
  };

  questionAdded$ = new EventEmitter();

  constructor(
    private i18nHelper: I18nHelperService
  ) {}

  // Bool check to see if a e=searched question has already been added to a questionnaire
  searchResultAlreadyInQuestionnaire(result: Question): boolean {
    let alreadyIn = false;

    this.questionnaire.questions.forEach(item => {
      if (result.title_content[this.i18nHelper.locale] === item.title_content[this.i18nHelper.locale])
        alreadyIn = true;
    });

    return alreadyIn;
  }

  addQuestionnaire(questions: any[]) {
    this.questionnaire.questions = questions;
  }

  addQuestion(question: Question) {
    this.questionnaire.questions.push(question);
    this.questionAdded$.emit();
  }

  getAutoSaveOnOauthReturn(): boolean {
    const hasAutoSave = Cookies.get(constants.OAUTH_SAVE_ON_RETURN);

    if (hasAutoSave == undefined) {
      return false;
    } else {
      return true;
    }
  }

  setAutoSaveOnOauthReturn() {
    Cookies.set(
      constants.OAUTH_SAVE_ON_RETURN,
      'true',
      {domain: environment.DOMAIN}
    );
  }

  removeAutoSaveOnOauthReturn() {
    Cookies.remove(constants.OAUTH_SAVE_ON_RETURN, {domain: environment.DOMAIN});
  }
}
